export const hotelTabTypes = {
  main: "MAIN",
  recommended: "RECOMMENDED",
};
